<template>
    <div class="favorite-button" @click="handleClick">
        <span class="favorite-button__icon">
            <img v-if="active" src="../images/watched.png" alt="已自选" />
            <img v-else src="../images/add_watch.png" alt="加自选" />
        </span>
        <span v-if="showCount" class="favorite-button__count">{{ formattedCount }}</span>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  count: {
    type: Number,
    default: 0
  },
  active: {
    type: Boolean,
    default: false
  },
  showCount: {
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;

  // 格式化数字（超过 1000 显示 K）
  const formattedCount = computed(() => {
    if (props.count >= 10000) {
      return (props.count / 1000).toFixed(1) + 'K';
    }
    return props.count.toString();
  });

  // 点击事件
  const handleClick = $event => {
    emit('click', $event);
  };
  return {
    formattedCount,
    handleClick
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.favorite-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.04rem;
    cursor: pointer;

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.32rem;
        height: 0.32rem;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &__count {
        font-size: 0.22rem;
        font-weight: 400;
        color: #999;
        line-height: 1.4;
    }
}
</style>
